export const extractOrders = mappingData => {
  const details = JSON.parse(localStorage.getItem('lenskart_rsf_cart'));
  const returnArr = [];
  if (details && details.items) {
    details.items.map(item => {
      const shopifyName = item.lenses.name;
      const prescriptionType = item.prescriptionType;
      const prescriptionTypeFormatted = prescriptionType.split(' ').join('_').toLowerCase();
      const productId = parseInt(item.eyeglass.sku, 10);
      const htmlDoc = item.productDetails.descriptionHtml;
      const dom_doc = new DOMParser().parseFromString(htmlDoc, 'text/xml');
      const oneClassNodeList = dom_doc.querySelectorAll('.one');
      const twoClassNodeList = dom_doc.querySelectorAll('.two');
      const nodeKeyArr = [...oneClassNodeList];
      const framevalue = [...twoClassNodeList];
      const index = nodeKeyArr.findIndex(item => item.innerHTML === 'Frame Type:');
      const frameType = framevalue[index].innerHTML;
      const stop = mappingData[shopifyName];
      const frameSpecific = stop.find(item => item['Frame Type'] === frameType);
      const returnObj = {
        addOns: frameSpecific.Addon,
        packageId: frameSpecific['Package Id'],
        powerType: prescriptionTypeFormatted,
        productId,
      };
      return returnArr.push(returnObj);
    });
  }
  localStorage.removeItem('lenskart_rsf_cart');
  return returnArr;
};
